import 'whatwg-fetch';
import $ from 'jquery';

window.$ = window.jQuery = $;
require('bootstrap');
require('./scripts');
require('./training/plan');
require('./training/program');
require('./training/select');
